<ng-container *ngIf="entityType == 'EKAMPUS'">
  <app-sidebarEKAMPUS></app-sidebarEKAMPUS>
</ng-container>
<ng-container *ngIf="entityType == 'IP'">
  <app-sidebarIP></app-sidebarIP>
</ng-container>
